import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDDvDSoIbyHISugj4fnAkfVLhfacznQ18c",
  authDomain: "scraptradedemo.firebaseapp.com",
  projectId: "scraptradedemo",
  storageBucket: "scraptradedemo.firebasestorage.app",
  messagingSenderId: "682250699607",
  appId: "1:682250699607:web:67a1f4bfdcaeeaa5f7f412"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

try {
  messaging = getMessaging(app);
} catch (error) {
  console.warn("Firebase Messaging is not supported in this environment (likely an insecure context or unsupported browser).");
}

export { messaging };